import { PropsWithChildren, useEffect } from "react"
import { hasText } from "utils/helpers"
import FeedbackContainer from "../components/feedback-container"
import FeedbackHeadline from "../components/feedback-headline"
import FeedbackPoints from "../components/feedback-points"
import { useMessages } from "../language/language"
import "./meme-frame.less"
import { usePlayState } from "play/hooks/use-play-state"
import { applyTimerToState, switchToNextScreenReducer } from "play/reducers"

export default function MemeFrame(props: PropsWithChildren<{}>) {
  const {
    memeUrl,
    lastScreenPoints,
    lastScreenIsCorrect,
    feedbackDurationInSeconds,
    modifyState,
  } = usePlayState()
  const msg = useMessages()

  useEffect(() => {
    const duration = feedbackDurationInSeconds * 1000

    // console.log('meme: setting duration', duration)

    const id = setTimeout(() => {
      modifyState((state) => {
        state.nextScreenButtonIsVisible = true
        state.internalPage = null
        const resp = state.screenFinishedResponse
        state.screenFinishedResponse = null
        if (!resp) {
          return console.error("ScreenFinishedResponse is empty")
        }

        applyTimerToState(state, resp)
        switchToNextScreenReducer(state, resp)
      })
    }, duration)
    return () => {
      clearTimeout(id)
    }
  }, [])

  let className = "meme-frame"
  let feedbackText: string
  const pointsText = msg.feedbackPointsToString(lastScreenPoints)

  if (lastScreenIsCorrect) {
    className += " correct"
    feedbackText = msg.feedback_correct
  } else {
    className += " incorrect"
    feedbackText = msg.feedback_incorrect
  }

  return (
    <article className={className}>
      <div className="meme-container">
        <FeedbackContainer>
          <FeedbackHeadline className="feedback">
            {feedbackText}
          </FeedbackHeadline>
          <FeedbackPoints isCorrect={lastScreenIsCorrect}>
            {pointsText}
          </FeedbackPoints>
        </FeedbackContainer>
        {hasText(memeUrl) && <img src={memeUrl!} />}
      </div>
    </article>
  )
}
